<template>
  <div>
    <div class="row">
      <div class="col-sm-12 m-t-10">
        <div
          v-t="'BULK_BLOCKED_TAB_DESCRIPTION'"
          class="bs-callout bs-callout-sm bs-callout-primary description"
        />
      </div>
      <div class="col-sm-6 col-sm-offset-6 m-t-10 m-b-15 text-right">
        <SearchBulkBlockedNumber />
      </div>
    </div>
    <div class="row">
      <div
        id="app"
        class="col-sm-12"
      >
        <BulkBlockNumbersForm
          :campaigns="campaigns"
          :action-status="actionStatus"
          @bulk-block="onBulkBlock"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BulkBlockNumbersForm from '../BulkBlockedNumbers/BulkBlockNumbersForm.vue';
import SearchBulkBlockedNumber from '../SearchBulkBlockedNumber';

import messages from '../../locales';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import { STATUS_ERROR, STATUS_SUCCESS, getStatus } from '@/store/helpers';

import { mapState, mapActions } from 'vuex';

export default {
  components: {
    BulkBlockNumbersForm,
    SearchBulkBlockedNumber,
  },
  computed: {
    ...mapState({
      campaigns: 'completedCampaignsWithoutStats',
    }),
    ...mapState('blockedNumbers', {
      actionStatus: (state) => getStatus(state, 'BULK_BLOCK_NUMBERS'),
    }),
  },
  mounted() {
    this.getCompletedCampaignsWithNoStats();
  },
  methods: {
    ...mapActions('blockedNumbers', ['uploadBulkBlockedNumbers']),
    ...mapActions(['getCompletedCampaignsWithNoStats']),
    async onBulkBlock(bulkBlockRequest) {
      await this.uploadBulkBlockedNumbers(bulkBlockRequest);
      if (this.actionStatus.status === STATUS_SUCCESS) {
        utilities.showToaster('success', this.$i18n.t('BULK_BLOCK_SUCESS'));
      }
      if (this.actionStatus.status === STATUS_ERROR) {
        utilities.errorHandler(this.actionStatus.error);
      }
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>